import { string as stringUtil } from '@eti/utils';
import { useTranslation } from '@eti/providers';
import { css, etiColors } from '@eti/styles';
import PropTypes from 'prop-types';

const numOfFlightsLabelContentStyles = css`
  color: ${etiColors.black};
  font-size: 0.875rem;
  font-weight: 400;
`;

const NumOfFlightsLabel = ({ filteredFlightsCount, flightsCount }) => {
  const { t } = useTranslation();

  const totalFlightsCountLabel = stringUtil.insertArgument(
    t('Result.SearchFilters.All.Flights.Label'),
    filteredFlightsCount,
  );
  const filteredFlightsCountLabel = stringUtil.insertArgument(
    t('Result.SearchFilters.Label'),
    filteredFlightsCount,
    flightsCount,
  );

  const numOfFlightsLabel =
    flightsCount !== filteredFlightsCount ? filteredFlightsCountLabel : totalFlightsCountLabel;

  return <span className={numOfFlightsLabelContentStyles}>{`: ${numOfFlightsLabel}`}</span>;
};

NumOfFlightsLabel.propTypes = {
  filteredFlightsCount: PropTypes.number,
  flightsCount: PropTypes.number,
};

export default NumOfFlightsLabel;
